import gql from 'graphql-tag';
// import { FRAGMENT_PRODUCT_CARD } from 'src/modules/products';
export const instagramsToLoad = 15;

import { AssetImageSubtype } from 'src/modules/assets';
// Copied to avoid error - GraphQLError [Object]: Syntax Error: Unexpected Name
// "undefined".
const FRAGMENT_PRODUCT_CARD = gql`
  fragment productCardFields on Product {
    id
    name_en
    name_de
    slug
    product_categories {
      id
      slug
    }
    product_subcategories @include(if: $withFilters) {
      id
      name_en
      name_de
    }
    location_types @include(if: $withFilters) {
      id
      name_en
      name_de
    }
    assets(where: {subtype: "${AssetImageSubtype.Cutout}"}, sort: "sorting:asc", limit: 1) {
    # assets(where: {subtype: "${AssetImageSubtype.Preview}"}) {
      subtype
      file {
        url
        alternativeText
        # width
        # height
      }
    }
    product_series {
      slug
      name_en
      name_de
      designer {
        id
        name
      }
    }
  }
`;

// NOTE: $withFilters argument is needed for FRAGMENT_PRODUCT_CARD
export const QUERY_ARTICLES_INSTAGRAM = gql`
  query Instagrams($start: Int = 0, $withFilters: Boolean! = true) {
    instagrams(start: $start, sort: "date:desc", limit: ${instagramsToLoad}) {
      id
      name
      caption_en
      caption_de
      products {
        ...productCardFields
      }
      media {
        url
        previewUrl
      }
    }
    instagramsCount
  }
  ${FRAGMENT_PRODUCT_CARD}
`;
